import React from 'react';
import { checkFreePackage } from '@src/services/package';
import Text from '../Shared/Text';

const CONST_NUMBER_SPEAKER = {
  FREE: 1,
  PRO: 10,
};

const numberSpeakerFeatures = ({ packages }) =>
  packages.map((pkg) => (
    <Text
      key={pkg.code}
      text={
        checkFreePackage(pkg?.code)
          ? CONST_NUMBER_SPEAKER.FREE
          : CONST_NUMBER_SPEAKER.PRO
      }
    />
  ));

export default numberSpeakerFeatures;
